<div
  aria-live="assertive"
  aria-label="Do not refresh the page"
  #refSpinner
  [ngStyle]="styleSpinner()"
></div>
